import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useSWR from 'swr';
import axios from 'axios';
import { apiHost } from '../utils/apiHost';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
});

const fetcher = (url) => axiosInstance.get(url).then((res) => res.data);
const fetcherIgnore404 = (url) =>
  axiosInstance.get(url).then((res) => res.data).catch((err) => {
    if (err.response?.status === 404) return { status: true, data: null };
    throw err;
  });

const toUrl = (fileName) => (fileName ? `${getApiBaseUrl()}/uploads/${fileName}` : null);

// Resolusi logo & favicon: punya cabang sendiri (jika toggle aktif) -> utama (global) -> null (pakai default statis app)
export const useBranding = () => {
  const { user } = useSelector((state) => state.auth);
  const cabangUuid = user?.cabang?.uuid || user?.cabanguuid || '';

  const { data: cabangConfigRes } = useSWR(
    cabangUuid ? `/getkonfigurasicabang?cabangUuid=${cabangUuid}` : null,
    fetcherIgnore404
  );
  const { data: utamaRes } = useSWR('/getpengaturanutama', fetcher);

  const cabangConfig = cabangConfigRes?.data || null;
  const utama = utamaRes?.data || {};

  const logoUrl =
    (cabangConfig?.logoTampilWebsite !== false && cabangConfig?.logo && toUrl(cabangConfig.logo)) ||
    toUrl(utama.logo) ||
    null;

  const faviconUrl =
    (cabangConfig?.logoTampilWebsite !== false && cabangConfig?.favicon && toUrl(cabangConfig.favicon)) ||
    toUrl(utama.favicon) ||
    null;

  return { logoUrl, faviconUrl };
};

// Update <link rel="icon"> di document secara dinamis, fallback ke favicon default kalau tidak ada
export const useDynamicFavicon = () => {
  const { faviconUrl } = useBranding();

  useEffect(() => {
    if (!faviconUrl) return;
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/png';
    link.rel = 'icon';
    link.href = faviconUrl;
    if (!link.parentNode) document.head.appendChild(link);
  }, [faviconUrl]);
};

export default useBranding;
